import React from 'react';
import clsx from 'clsx';
import { useLocation, NavLink } from 'react-router-dom';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { COLOR_BLUE, COLOR_TEXT } from '../styles/colors';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';

interface ActionProps {
  icon?: any; // render function, component
  children: React.ReactNode;
  className?: string;
  selectedClassName?: string;
  iconClassName?: string;
  href?: string;
  isActive?: (match:any, location:any) => boolean;
  target?: string;
  disabled?: boolean;
  externalLink?: boolean;
  onClick?: (event: any) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  action: {
    display: 'flex',
    alignItems: 'center',
    appearance: 'none',
    background: 'none',
    border: 'none',
    fontFamily: FONT_PROXIMA_NOVA,
    color: COLOR_TEXT,
    cursor: 'pointer',
    textDecoration: 'none',
    overflow: 'hidden',

    '&:hover': {
      textDecoration: 'underline',
      color: COLOR_BLUE,
    },
  },
  disabled: {
    opacity: '0.6',
    cursor: 'not-allowed',

    '&:hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
  actionIcon: {
    width: '32px',
    height: '32px',
    marginRight: theme.spacing(1),
  },
}), { name: Action.name });

export default function Action (props: ActionProps) {
  const {
    children,
    className,
    selectedClassName,
    icon,
    iconClassName,
    href = '',
    target,
    disabled = false,
    externalLink = false,
    isActive = () => {},
    onClick = () => {},
  } = props;
  const classes = useStyles();
  const location = useLocation();

  const Icon = icon;
  const Wrapper:any = (href && !disabled)
    ? (externalLink ? 'a' : NavLink)
    : 'button';

  const wrapperProps = (href && !disabled)
    ? (externalLink
        ? {
            href,
            target,
            onClick: !disabled ? onClick : undefined,
          }
        : {
            to: href.includes('?') ? href : `${href}${location.search}`,
            activeClassName: selectedClassName,
            target,
            isActive,
            onClick: !disabled ? onClick : undefined,
          }
      )
    : {
        onClick: !disabled ? onClick : undefined,
      };

  return (
    <Wrapper
      className={clsx(
        classes.action,
        disabled && classes.disabled,
        className,
      )}
      {...wrapperProps}
    >
      {!!icon && (
        <Icon className={clsx(classes.actionIcon, iconClassName)} />
      )}
      {children}
    </Wrapper>
  );
}
